import { Selector } from '@ngxs/store';

import { ActiveVehicleState, ActiveVehicleStateModel } from './active-vehicle.state';
import { ActiveVehicle } from '../../core/models';

export class ActiveVehicleGetterState {

  @Selector([ActiveVehicleState])
  static getActiveVehicles(state: ActiveVehicleStateModel): ActiveVehicle[] {
    return state.ids.map(id => state.entities[id]);
  }
}
